// extracted by mini-css-extract-plugin
var _1 = "CustomerManagementCustomerTransferTable-module__button-container";
var _2 = "CustomerManagementCustomerTransferTable-module__container";
var _3 = "CustomerManagementCustomerTransferTable-module__danger";
var _4 = "CustomerManagementCustomerTransferTable-module__transaction-action-label";
export { _1 as "button-container", _2 as "container", _3 as "danger", _4 as "transaction-action-label" }
